// The welcome message on the Customers card (migration 093).

import { inZone } from './companyDate';
//
// welcome_sent_at and welcome_channel arrive on the customer row through
// GET /api/customers (c.*). The label names the day (in the company's time
// zone, like every other date the app shows) and how it went; the send is
// POST /api/customers/:id/welcome, with force when one already went.

const CHANNEL_WORDS = { email: 'email', sms: 'text', both: 'text and email' };

// "Welcomed Oct 12 (email)", or null when no welcome has gone.
export function welcomeLabel(row, timezone) {
  if (!row || !row.welcome_sent_at) return null;
  const day = new Date(row.welcome_sent_at).toLocaleDateString('en-US', inZone(timezone, {
    month: 'short', day: 'numeric',
  }));
  const how = CHANNEL_WORDS[row.welcome_channel];
  return how ? `Welcomed ${day} (${how})` : `Welcomed ${day}`;
}

export function welcomeAlreadySent(row) {
  return Boolean(row && row.welcome_sent_at);
}

// The action's own label and its confirm dialog text.
export function welcomeActionLabel(row) {
  return welcomeAlreadySent(row) ? 'Send welcome again' : 'Send welcome';
}

export function welcomeConfirmText(row) {
  const name = `${row.first_name || ''} ${row.last_name || ''}`.trim() || 'this customer';
  return welcomeAlreadySent(row)
    ? `Send the welcome message to ${name} again? They already received it.`
    : `Send the welcome message to ${name} now?`;
}

// The body of the send: force exactly when one already went.
export function welcomeBody(row) {
  return { force: welcomeAlreadySent(row) };
}
